import { render, staticRenderFns } from "./upPopup.vue?vue&type=template&id=1024017e&"
import script from "./upPopup.vue?vue&type=script&lang=js&"
export * from "./upPopup.vue?vue&type=script&lang=js&"
import style0 from "./upPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports